import React from 'react';
import logo from '../assets/vertikalogo.jpg'; // Import your logo image
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa'; // Social media icons

const Footer = () => {
    return (
        <footer className="bg-[#2e3c47] text-white py-4"> {/* Reduced padding */}
            <div className="container mx-auto flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0 lg:space-x-6">

                {/* Logo Section */}
                <div className="flex justify-center lg:justify-start">
                    <img src={logo} alt="Vertikal Logo" className="w-40 h-auto" /> {/* Kept the logo size smaller (width: 160px) */}
                </div>

                {/* Links Section */}
                <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-2 lg:space-y-0 lg:space-x-6 text-center lg:text-left">
                    <a href="#home" className="text-gray-300 hover:text-white transition">Home</a>
                    <a href="#about" className="text-gray-300 hover:text-white transition">About Us</a>
                    <a href="#trips" className="text-gray-300 hover:text-white transition">Trips</a>
                    <a href="#contact" className="text-gray-300 hover:text-white transition">Contact</a>
                </div>

                {/* Social Media Section */}
                <div className="flex justify-center space-x-4">
                    <a href="https://facebook.com" className="text-gray-300 hover:text-blue-500 transition">
                        <FaFacebookF size={20} />
                    </a>
                    <a href="https://instagram.com" className="text-gray-300 hover:text-pink-500 transition">
                        <FaInstagram size={20} />
                    </a>
                    <a href="https://twitter.com" className="text-gray-300 hover:text-blue-400 transition">
                        <FaTwitter size={20} />
                    </a>
                </div>
            </div>

            {/* Copyright Section */}
            <div className="text-center mt-4">
                <p className="text-gray-400 text-sm">© 2025 Vertikal. All rights reserved.</p> {/* Reduced text size */}
            </div>
        </footer>
    );
};

export default Footer;
